const MeasurementNameMap: { [key: string]: string } = {
    shoulder: 'Shoulder',
    underBust: 'Under Bust',
    rightForearm: 'Right Forearm',
    leftForearm: 'Left Forearm',
    leftBiceps: 'Left Biceps',
    rightBiceps: 'Right Biceps',
    leftCalf: 'Left Calf',
    rightCalf: 'Right Calf',
    neck: 'Neck',
    leftThigh: 'Left Thigh',
    rightThigh: 'Right Thigh',
    bust: 'Bust',
    narrowWaist: 'Narrow Waist',
    hip: 'Hip',
    navelGirth: 'Navel Girth',
    head: 'Head',
    trouserWaistline: 'Trouser Waistline',
    highTrouserWaistline: 'High Trouser Waistline',
    backShoulderWidth: 'Back Shoulder Width',
    backNeckToWaist: 'Back Neck to Waist',
    rightPantInseam: 'Right Pant Inseam',
    leftPantInseam: 'Left Pant Inseam',
    backNeckToHip: 'Back Neck to Hip',
    rightTibia: 'Right Tibia',
    leftTibia: 'Left Tibia',
    height: 'Height',
    rightOutleg: 'Right Outleg',
    leftOutleg: 'Left Outleg',
    leftHighOutleg: 'Left High Outleg',
    rightHighOutleg: 'Right High Outleg',
    bellyOutleg: 'Belly Outleg',
    highTrouserWaistlineToGround: 'High Trouser Waistline to Ground',
    trouserWaistlineToGround: 'Trouser Waistline to Ground',
    longestNeckToWrist: 'Longest Neck to Wrist',
    narrowWaistToGround: 'Narrow Waist to Ground',
    leftFootLength: 'Left Foot Length',
    rightFootLength: 'Right Foot Length',
    leftFootWidth: 'Left Foot Width',
    rightFootWidth: 'Right Foot Width',
    leftFootTreadWidth: 'Left Foot Tread Width',
    rightFootTreadWidth: 'Right Foot Tread Width',
    longestFootLength: 'Longest Foot Length',
    widestFootWidth: 'Widest Foot Width',
    handLength: 'Hand Length',
    handWidth: 'Hand Width',
    handFingerLength: 'Hand Finger Length',
    rightWrist: 'Right Wrist',
    leftWrist: 'Left Wrist',
    neckBase: 'Neck Base',
    topHip: 'Top Hip',
    maximumHip: 'Maximum Hip',
    backNeckToGround: 'Back Neck to Ground',
    shoulderToWaist: 'Shoulder to Waist',
    waistToTopHip: 'Waist to Top Hip',
    waistToMaximumHip: 'Waist to Maximum Hip',
    orbitaleToGround: 'Orbitale to Ground',
    waistToKnee: 'Waist to Knee',
    shoulderToBust: 'Shoulder to Bust',
    minimumLegGirth: 'Minimum Leg Girth',
    shoulderLength: 'Shoulder Length',
    outerArmLength: 'Outer Arm Length',
};

export default MeasurementNameMap;
